import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorizationService } from '@ng-cloud/badger-core/services/authorization.service';
import { ThemeService } from '@ng-cloud/badger-core/services/theme.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'bt-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class NavbarComponent implements OnDestroy, AfterViewInit {
  @Input() title: string;
  @Input() appIcon: string;

  username = '';
  currentTheme = '';

  @ViewChild('profileMenuButton') set profileMenuButton(profileMenuButton: MatButton) {
    this._profileMenuButton = profileMenuButton;
    if (this._profileMenuButton) {
      this.resizeObservable.observe(this._profileMenuButton._elementRef.nativeElement);
    }
  }

  _profileMenuButton: MatButton;
  @ViewChild('profileMenuTrigger') profileMenuTrigger: MatMenuTrigger;

  private resizeObservable: ResizeObserver;

  constructor(public authService: AuthorizationService,
              public themeService: ThemeService,
              private router: Router,
              private elRef: ElementRef) {
    this.authService.getCurrentUser().subscribe(user => this.username = user.email);
    themeService.themes().subscribe(theme => this.currentTheme = theme);
  }

  signOut(): void {
    this.authService.signOut();
    // noinspection JSIgnoredPromiseFromCall
    this.router.navigate(['/']);
  }

  ngAfterViewInit(): void {
    this.createResizeObservable();
  }

  createResizeObservable() {
    this.resizeObservable = new ResizeObserver(entries => {
      if (entries[0].contentRect.width === 0) {
        this.profileMenuTrigger.closeMenu();
      }
    });
  }

  ngOnDestroy() {
    this.resizeObservable.disconnect();
  }

  get height(): number {
    return this.elRef.nativeElement.offsetHeight;
  }
}
